import type { ReactNode } from "react";
import "./Layout.module.css";

type DefaultLayoutProps = {
  children: ReactNode;
};

const DefaultLayout = ({ children }: DefaultLayoutProps) => {
  return (
    <div className="app w-[100%] max-w-[640px] flex flex-col mx-auto bg-[#002558] min-h-screen">
      <div className="sm:overflow-x-hidden bg-white grow flex flex-col">
        {children}
      </div>
    </div>
  );
};

export default DefaultLayout;
